// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ji-0";
export var fileCarousel = "_ji-2";
export var removeFileButton = "_ji-1";